module.exports = __webpack_public_path__ + "img/hontai_ItalianRed.eac88ee4.png";